<template lang="pug">
div
  el-row
    el-row.marginTop
      el-col.inputDiv(:span="12")
        app-display(
          label="Tipo de cadastro:",
          :content="tipo",
        )
      el-col.inputDiv(:span="12")
        app-display(
          label="Data de cadastro:",
          :content="this.dataCadastro",
        )
      el-col.inputDiv(v-if="isMa", :span="12")
        app-display(
          label="Bairros:",
          :content="getBairros",
        )
  el-row(v-if="!withOutQualificacao")
    app-divider(label="Qualificação")
    el-row.marginTop
      el-col(:span="24")
        app-display(
          label="Tipo de informação solicitada:",
          :content="tipoInformacaoDesejada",
        )
      el-col(:span="24")
        .label
          b.text-color Justificativa de solicitação:
          .texto.marginTop.text-color(v-html="getJustificativa")
</template>
<script>
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppDisplay,
    AppDivider
  },
  props: {
    informacaoDesejada: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    dataCadastro: {
      type: String,
      required: true
    },
    withOutQualificacao: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isMa: process.env.ESTADO === 'ma'
    }
  },
  computed: {
    tipoInformacaoDesejada () {
      if (this.informacaoDesejada.descricaoOutro) {
        return 'Outros - ' + this.informacaoDesejada.descricaoOutro
      }
      if (this.informacaoDesejada.tipoInformacao != null && this.informacaoDesejada.tipoInformacao.descricao === 'Outro') {
        return this.informacaoDesejada.outro
      }
      if (this.informacaoDesejada.tipoInformacao != null && this.informacaoDesejada.tipoInformacao.descricao) {
        return this.informacaoDesejada.tipoInformacao.descricao
      }
      return '-'
    },
    getJustificativa () {
      return this.informacaoDesejada.justificativa !== null ? this.informacaoDesejada.justificativa : '-'
    },
    getBairros () {
      if (this.informacaoDesejada?.imovel?.bairros) {
        return this.informacaoDesejada.imovel.bairros.map(bairro => bairro).join(', ')
      }
      return '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.marginTop {
  padding-top: 15px;
}
.label {
  font-size: 14px;
}

.text-color {
  color: #606266;
}

@media (max-width: 780px) {
  .marginTop {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacaoDesejada.vue